export default __webpack_public_path__ + "media/vendors/app_store_download-7a4d04ac.svg";